// extracted by mini-css-extract-plugin
export default {"primary":"primary__26eJ1","outlined":"outlined__kNC7b"};